type Tag = {
  tag: 'creategame' | 'startplay' | 'sleepplay' | 'resetplay' | 'pauseplay' | 'endgame'
  description: string
}

export type CreateGame = Tag & { tag: 'creategame' }
export type StartPlay = Tag & { tag: 'startplay' }
export type SleepPlay = Tag & { tag: 'sleepplay' }
export type ResetPlay = Tag & { tag: 'resetplay' }
export type PausePlay = Tag & { tag: 'pauseplay' }
export type EndGame = Tag & { tag: 'endgame' }

export type GameAction = CreateGame | StartPlay | SleepPlay | ResetPlay | PausePlay | EndGame

export class GameActions {
  public static CreateGame: CreateGame = <CreateGame>{
    tag: 'creategame'
  }

  public static StartPlay: StartPlay = <StartPlay>{
    tag: 'startplay'
  }

  public static SleepPlay: SleepPlay = <SleepPlay>{
    tag: 'sleepplay'
  }

  public static ResetPlay: ResetPlay = <ResetPlay>{
    tag: 'resetplay'
  }

  public static PausePlay: PausePlay = <PausePlay>{
    tag: 'pauseplay'
  }

  public static EndGame: EndGame = <EndGame>{
    tag: 'endgame'
  }

  static isCreateGame(a: GameAction): a is CreateGame {
    return a.tag === 'creategame'
  }

  static isStartPlay(a: GameAction): a is StartPlay {
    return a.tag === 'startplay'
  }

  static isSleepPlay(a: GameAction): a is SleepPlay {
    return a.tag === 'sleepplay'
  }

  static isResetPlay(a: GameAction): a is ResetPlay {
    return a.tag === 'resetplay'
  }

  static isPausePlay(a: GameAction): a is PausePlay {
    return a.tag === 'pauseplay'
  }

  static isEndGame(a: GameAction): a is EndGame {
    return a.tag === 'endgame'
  }
}
